import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';
import { AlertIcon, CheckCircleIcon } from '../icons';

export type AlertTone = 'info' | 'success' | 'error';

const TONES: Record<AlertTone, string> = {
  info: 'border-border bg-surface-muted text-fg',
  success: 'border-border bg-success-soft text-success-soft-fg',
  error: 'border-border bg-danger-soft text-danger-soft-fg',
};

export interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  tone?: AlertTone;
}

/** Inline status message used for form errors and notices. */
export function Alert({ tone = 'info', className, children, ...props }: AlertProps) {
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn('flex items-start gap-2 rounded-lg border px-3 py-2 text-sm', TONES[tone], className)}
      {...props}
    >
      {tone === 'success' ? (
        <CheckCircleIcon className="mt-0.5 h-4 w-4 shrink-0" />
      ) : (
        <AlertIcon className="mt-0.5 h-4 w-4 shrink-0" />
      )}
      <span>{children}</span>
    </div>
  );
}
